const sendNewNotification = {
	id: 'sendNewNotification',
	selectionType: 'single',
	label: 'notificationVisitor.sendNewNotification',
	functionality: 'NOTIFICATION_SEND_TO_VISITOR',
	checkAvailability: function() {
		return true;
	},
	runAction: function(action, model, registries) {
		const dataToSend = registries[0];
		dataToSend.isAction = true;

		this.$puiEvents.$emit('pui-modalDialogForm-sendToVisitor-' + model.name + '-show', dataToSend);
	}
};

export default {
	actions: [sendNewNotification]
};
